/* unplugin-vue-components disabled */import { render } from "./AppUpload.vue?vue&type=template&id=b541442e&scoped=true"
import script from "./AppUpload.vue?vue&type=script&lang=js"
export * from "./AppUpload.vue?vue&type=script&lang=js"

import "./AppUpload.vue?vue&type=style&index=0&id=b541442e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b541442e"]])

export default __exports__